import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-real-estate',
  templateUrl: './real-estate.component.html'
})
export class RealEstateComponent implements OnInit {
  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }

}
